import './App.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { lazy, Suspense } from 'react';

/* webpackPrefetch: true on Premium so it loads ASAP on / */
const Premium = lazy(() => import(/* webpackChunkName: "premium", webpackPrefetch: true */ './premium/Premium'));

/* Other routes — only loaded when navigated to */
const MainWrapper = lazy(() => import(/* webpackChunkName: "main-old" */ './mainBeauty/MainWrapper'));
const Designers = lazy(() => import(/* webpackChunkName: "designers" */ './Designers'));
const Designersss = lazy(() => import(/* webpackChunkName: "designers2" */ './Designersss'));
const Takanon = lazy(() => import(/* webpackChunkName: "takanon" */ './components/takanon/Takanon'));
const Thanks = lazy(() => import(/* webpackChunkName: "thanks" */ './thank/Thanks'));
const WorksGallery = lazy(() => import(/* webpackChunkName: "gallery" */ './screens/WorksGallery'));
const Upgraded = lazy(() => import(/* webpackChunkName: "upgraded" */ './upgraded/Upgraded'));
const General = lazy(() => import(/* webpackChunkName: "general" */ './general/General'));
const Blog = lazy(() => import(/* webpackChunkName: "blog" */ './blog/Blog'));
const BlogArticle = lazy(() => import(/* webpackChunkName: "blog-article" */ './blog/BlogArticle'));
const NotFound = lazy(() => import(/* webpackChunkName: "notfound" */ './components/NotFound/NotFound'));

function App() {
  return <>
 <Router>
  <Suspense fallback={<div></div>}>
    <Routes>
    <Route path="/" index element={<Premium/>}/>
    <Route path="/premium"  element={<MainWrapper/>}/>

    <Route path="/מעצבים נוסף"  element={<Designersss/>}/>
    <Route path="/מעצבים"  element={<Designers/>}/>
    <Route path="/תקנון"  element={<Takanon/>}/>

    <Route path="/תודה"  element={<Thanks/>}/>
    <Route path="/gallery"  element={<WorksGallery/>}/>
    <Route path="/upgraded"  element={<Upgraded/>}/>
    <Route path="/general"  element={<General/>}/>
    <Route path="/blog"  element={<Blog/>}/>
    <Route path="/blog/:slug"  element={<BlogArticle/>}/>
    <Route path="/404" element={<NotFound/>}/>
    <Route path="*" element={<NotFound/>}/>
 </Routes>
  </Suspense>
 </Router>
  </>
}

export default App;
